"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadSidebar = void 0;
const react_1 = __importStar(require("react"));
require("./index.scss");
const DownloadSidebarForm_1 = require("@Components/Sidebars/DownloadSidebar/DownloadSidebarForm");
const DownloadSidebarSubmitted_1 = require("@Components/Sidebars/DownloadSidebar/DownloadSidebarSubmitted");
const sidebar_download_type_1 = require("@App/enum/sidebar-download-type");
const ExportCatalogForm_1 = __importDefault(require("@Components/Sidebars/DownloadSidebar/DownloadSidebarForm/ExportCatalogForm"));
const RoyaltyStatementDownloadForm_1 = require("@Components/Sidebars/DownloadSidebar/DownloadSidebarForm/RoyaltyStatementDownloadForm");
const MatchHistoryDownloadForm_1 = __importDefault(require("@Components/Sidebars/DownloadSidebar/DownloadSidebarForm/MatchHistoryDownloadForm"));
const MatchRecordingsDownloadForm_1 = __importDefault(require("@Components/Sidebars/DownloadSidebar/DownloadSidebarForm/MatchRecordingsDownloadForm"));
const ExportOverclaimsForm_1 = __importDefault(require("@Components/Sidebars/DownloadSidebar/DownloadSidebarForm/ExportOverclaimsForm"));
const mobx_react_1 = require("mobx-react");
const DownloadSidebar = (props) => {
    const [isFormSubmitted, setIsFormSubmitted] = (0, react_1.useState)(false);
    const determineFormComponent = () => {
        switch (props.sidebarDownloadType) {
            case sidebar_download_type_1.SidebarDownloadType.CatalogExport:
                return react_1.default.createElement(ExportCatalogForm_1.default, { setIsFormSubmitted: setIsFormSubmitted });
            case sidebar_download_type_1.SidebarDownloadType.SongwriterCatalogExport:
                return react_1.default.createElement(ExportCatalogForm_1.default, { setIsFormSubmitted: setIsFormSubmitted, songwriterCatalog: true });
            case sidebar_download_type_1.SidebarDownloadType.MatchHistoryExport:
                return react_1.default.createElement(MatchHistoryDownloadForm_1.default, { setIsFormSubmitted: setIsFormSubmitted });
            case sidebar_download_type_1.SidebarDownloadType.MatchedRecordingsExport:
                return react_1.default.createElement(MatchRecordingsDownloadForm_1.default, { setIsFormSubmitted: setIsFormSubmitted });
            case sidebar_download_type_1.SidebarDownloadType.OverclaimExport:
                return react_1.default.createElement(ExportOverclaimsForm_1.default, { setIsFormSubmitted: setIsFormSubmitted });
            case sidebar_download_type_1.SidebarDownloadType.RoyaltyStatements:
                return (react_1.default.createElement(RoyaltyStatementDownloadForm_1.RoyaltyStatementDownloadForm, { setIsFormSubmitted: setIsFormSubmitted, downloadData: props.downloadData }));
            default:
                throw new Error('No case established for [props.sidebarDownloadType]');
        }
    };
    return (react_1.default.createElement("div", { className: "download-sidebar" }, !isFormSubmitted ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(DownloadSidebarForm_1.DownloadSidebarForm, { formComponent: determineFormComponent(), formSubText: props.sidebarDownloadType.formText }))) : (react_1.default.createElement(DownloadSidebarSubmitted_1.DownloadSidebarSubmitted, { closeSidebar: props.closeSidebar, subText: props.sidebarDownloadType.submittedText }))));
};
exports.DownloadSidebar = DownloadSidebar;
exports.default = (0, mobx_react_1.observer)(exports.DownloadSidebar);
